import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function RiwayatCategory() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const limit = 20;

  useEffect(() => {
    fetch(baseUrl + "api/v1/riwayat")
      .then((res) => res.json())
      .then((data) => setCategories(Array.isArray(data) ? data : []))
      .catch(() => setCategories([]));
  }, []);

  const filteredRiwayat = categories.filter((riwaya) =>
    `${riwaya.name}`.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const displayedRiwayat = filteredRiwayat.slice(0, page * limit);

  return (
    <>
      <div className="search-input">
        <input
          type="text"
          placeholder="Search narration..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="reciters-grid">
        {displayedRiwayat.map((category) => (
          <button
            key={category.id}
            className="reciter-card"
            onClick={() => navigate(`/narration/${category.slug}`)}
          >
            <img
              src={`${baseUrl}storage/images/quraan-icon.png`}
              alt={category.name}
            />
            <h3>{category.name}</h3>
          </button>
        ))}
      </div>

      {displayedRiwayat.length < filteredRiwayat.length && (
        <button className="load-more" onClick={() => setPage(page + 1)}>
          Load More
        </button>
      )}
    </>
  );
}

export default RiwayatCategory;
